export const Customizations = {
    namespaced: true,
    state: {
        mobile_view: false,
        mobile_siderbar_toggled: false,
    },
    mutations: {
        change_device_view(state:any) {
            state.mobile_view = !state.mobile_view;
        },

        togglemobilesidebar(state: any) {
            state.mobile_siderbar_toggled = !state.mobile_siderbar_toggled;
        },

        togglemobilesidebartofalse(state: any) {
            state.mobile_siderbar_toggled = false;
        }
    },
    actions: { },
    getters: {
        view_status_getter(state:any) {
            return state.mobile_view = true;
        }
    },
    modules: {}
}